<template>
  <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)"
               v-style:paddingRight="$valueByBreakpoint($finPadding.right)"
               fluid>
    <v-row>
      <v-col class="py-0" cols="12">
        <h4 class="mt-8 mb-6">Kurzfristige Wertentwicklung</h4>
      </v-col>
      <v-col md="8" sm="10" xs="12">
        <fin-data-table :headers="growthHeaders" :mobile-breakpoint="Number.MAX_SAFE_INTEGER"
                        :resolver="[instrument]"
                        class="performance-table"
                        disable-row-hover hide-default-footer hide-default-header transparent/>
      </v-col>
    </v-row>
    <v-row :class="!isDistributing ? 'mb-6' : ''">
      <v-col class="py-0" cols="12">
        <h4>
          <fin-lexicon-text auto-solve class="mt-5 mb-6"
                            text="Langfristige Wertentwicklung annualisiert"></fin-lexicon-text>
        </h4>
      </v-col>
      <v-col md="8" sm="10" xs="12">
        <fin-data-table :headers="longTermGrowthHeaders" :mobile-breakpoint="Number.MAX_SAFE_INTEGER"
                        :resolver="[instrument]"
                        class="performance-table"
                        disable-row-hover hide-default-footer hide-default-header transparent/>

      </v-col>
    </v-row>
    <v-row v-if="isDistributing">
      <v-col class="py-0" cols="12">
        <h4>
          <fin-lexicon-text auto-solve class="mt-5 mb-6" text="Gesamtrendite annualisiert*"></fin-lexicon-text>
        </h4>
      </v-col>
      <v-col md="8" sm="10" xs="12">
        <fin-data-table :headers="renditeHeader" :mobile-breakpoint="Number.MAX_SAFE_INTEGER"
                        :resolver="[instrument]"
                        class="mb-2 performance-table"
                        disable-row-hover hide-default-footer hide-default-header transparent/>
      </v-col>
      <fin-lexicon-text auto-solve class="mb-6"
                        text="* Gesamtrendite inklusive aller Zinsen oder Dividenden, die in dem betreffenden Zeitraum ausgeschüttet wurden"/>
    </v-row>
  </v-container>
</template>

<script>
import FinDataTable from "@/components/common/DataTable/FinDataTable"
import FinLexiconText from "@/components/common/lexicon/LexiconText"
import {TablePresets} from "@/components/common/DataTable/DefaultHeaders"

export default {
  name: "fin-instrument-performance-page",
  components: {FinLexiconText, FinDataTable},
  props: {
    instrument: {
      required: true
    }
  },
  data() {
    return {
      growthHeaders: TablePresets.createProfileGrowthHeaders(),
      renditeHeader: TablePresets.createProfileRenditeHeaders(),
      longTermGrowthHeaders: TablePresets.createProfileLongTermGrowthHeaders(),
    }
  },
  computed: {
    isDistributing() {
      if (this.instrument.assetClass === 'SHARE') {
        return true
      } else {
        return this.instrument.dividendTreatment === 'Distributes'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  font-size: 20px;
  font-weight: bold;
  line-height: 1.1;
}
</style>
